export var LiveboardPageUTMSource;
(function (LiveboardPageUTMSource) {
    LiveboardPageUTMSource["AnswerPage"] = "answer-page";
    LiveboardPageUTMSource["EurekaSearch"] = "eureka-search";
    LiveboardPageUTMSource["HomePage"] = "homepage";
    LiveboardPageUTMSource["HomePageFavouritesCarousel"] = "favourites-carousel";
    LiveboardPageUTMSource["HomePageWatchList"] = "homepage-watchlist";
    LiveboardPageUTMSource["LiveboardListPage"] = "liveboard-list-page";
    LiveboardPageUTMSource["MonitorPage"] = "monitor-page";
})(LiveboardPageUTMSource || (LiveboardPageUTMSource = {}));
//# sourceMappingURL=mixpanel-liveboard-properties.js.map